<div class="main_content px-3 position-relative">
  
    <div class="container-fluid py-3">
      <div class="title mb-4">
        <h3>Home page Ads</h3>
      </div>
      <div class="white_box w-100 d-flex justify-content-between align-items-center shadow p-4 mb-3">
        <div>
            <label class="mr-2">Image File *: </label>
            <input type="file" (change)="imageFileChange($event)" [(ngModel)]="fileLoc"/>
        </div>
        <div>
            <label class="mr-2">Position: </label>
            <input type="radio" value="1" [(ngModel)]="isOnLeft"/> Left
            <input type="radio" value="0" [(ngModel)]="isOnLeft"/> Right
        </div>
        <div>

            <input type="checkbox" [(ngModel)]="isAdFirst"/>
            <label class="ml-2"> Is Ad seen first?</label>

        </div>
        <div>
            <label class="mr-2">Disapear Time*: </label>
            <input type="number" placeholder="Disapear time " [(ngModel)]="disappearTime"/>
        </div>
        <div>
           <label class="mr-2">Ad Link(Optional)</label>
           <input type="text" placeholder="Ad link " [(ngModel)]="adLink"/>
        </div>
        <button class="btn btn-success" (click)="createAd()">Add Homepage Ad</button>

        

      </div>

      <div class="row"   class="mt-3">
        <div class="col-lg-12 col-md-12">
          <div class="white_box shadow p-3">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Image</th>
                  <th scope="col">View Time(seconds)</th>
                  <th scope="col">Is First</th>
                  <th scope="col">Location</th>
                  <th scope="col">Action </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ad of ads; let i = index">
                    <td>{{i+1}}</td>
                    <td><img (click)="showImagePopup(ad.imageLocation)" [src]='imgUrl + ad.imageLocation' style="max-width: 6rem; cursor: pointer;"/></td>
                    <td>{{ad.disappearTime}}</td>
                    <td>{{ad.isFirstAd == '1' ? 'Yes' : 'No'}}</td>
                    <td>{{ad.isOnLeft ? 'Left' : 'Right'}}</td>
                    <td><button class='my-button-3' (click)="deleteAd(ad.id)" ><i class='fa fa-trash'></i></button></td>
                </tr>
             </tbody>
            </table>
        </div>
    </div>
</div>
</div>
  <!-------------------------------->
  <div class="container-fluid py-3 mb-4">
    <div class="title mb-4">
      <h3>Other Site Infos:</h3>
    </div>
    <div class="white_box w-100 d-flex justify-content-start  align-items-center align-items-center shadow p-4 mb-3">
      <div class="mr-5">
          <label class="mr-2">Home page top side Message:</label>
          <input class="form-control" type="text" placeholder="message to show top side" [(ngModel)]="topSideHomeMessage"/>
      </div>
      <button (click)='setTopSideHomeMessage()' class="btn btn-success"><i class="fa fa-check"></i> Set!</button>
    </div>
  </div>

  <!------------------------------>
</div>